module.exports = __webpack_public_path__ + "img/background-dots-sm.ab9ba89.jpg";